// import { useState, useEffect, useRef } from 'react';
// // import { createClient } from '@supabase/supabase-js';
// import {
//   Calendar,
//   Clock,
//   MapPin,
//   Heart,
//   Sparkles,
//   Users,
//   Shield,
//   ChevronDown,
//   X,
//   CheckCircle,
//   Flower2,
//   Wind,
//   Star,
//   MessageCircle,
//   HandHeart,
//   Utensils,
//   ArrowRight,
//   AlertCircle,
// } from 'lucide-react';

// // const supabase = createClient(
// //   import.meta.env.VITE_SUPABASE_URL,
// //   import.meta.env.VITE_SUPABASE_ANON_KEY
// // );

// const REGISTRATION_OPEN_DATE = new Date('2026-05-01T00:00:00');

// function useCountdown(target: Date) {
//   const [diff, setDiff] = useState(target.getTime() - Date.now());
//   useEffect(() => {
//     const id = setInterval(() => setDiff(target.getTime() - Date.now()), 1000);
//     return () => clearInterval(id);
//   }, [target]);
//   const total = Math.max(0, diff);
//   const d = Math.floor(total / 86400000);
//   const h = Math.floor((total % 86400000) / 3600000);
//   const m = Math.floor((total % 3600000) / 60000);
//   const s = Math.floor((total % 60000) / 1000);
//   return { d, h, m, s, past: diff <= 0 };
// }

// function useInView(threshold = 0.15) {
//   const ref = useRef<HTMLDivElement>(null);
//   const [visible, setVisible] = useState(false);
//   useEffect(() => {
//     const el = ref.current;
//     if (!el) return;
//     const obs = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setVisible(true);
//           obs.disconnect();
//         }
//       },
//       { threshold }
//     );
//     obs.observe(el);
//     return () => obs.disconnect();
//   }, [threshold]);
//   return { ref, visible };
// }

// interface FormData {
//   full_name: string;
//   email: string;
//   phone: string;
//   hear_about: string;
//   intention: string;
// }

// const INITIAL_FORM: FormData = {
//   full_name: '',
//   email: '',
//   phone: '',
//   hear_about: '',
//   intention: '',
// };

// export default function WomenTransform() {
//   const [modalOpen, setModalOpen] = useState(false);
//   const [successOpen, setSuccessOpen] = useState(false);
//   const [infoOpen, setInfoOpen] = useState(false);
//   const [form, setForm] = useState<FormData>(INITIAL_FORM);
//   const [submitting, setSubmitting] = useState(false);
//   const [error, setError] = useState('');
//   const [scrolled, setScrolled] = useState(false);
//   const [activeSection, setActiveSection] = useState('');
//   const regCountdown = useCountdown(REGISTRATION_OPEN_DATE);
//   const registrationIsOpen = regCountdown.past;

//   useEffect(() => {
//     const onScroll = () => setScrolled(window.scrollY > 60);
//     window.addEventListener('scroll', onScroll);
//     return () => window.removeEventListener('scroll', onScroll);
//   }, []);

//   useEffect(() => {
//     if (modalOpen || successOpen || infoOpen) {
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.body.style.overflow = '';
//     }
//     return () => {
//       document.body.style.overflow = '';
//     };
//   }, [modalOpen, successOpen, infoOpen]);

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     setError('');
//     if (!form.full_name.trim() || !form.email.trim()) {
//       setError('Please fill in your name and email.');
//       return;
//     }
//     setSubmitting(true);
//     // const { error: dbErr } = await supabase.from('registrations').insert([form]);
//     setSubmitting(false);
//     // if (dbErr) {
//     //   if (dbErr.code === '23505') {
//     //     setError('This email is already registered.');
//     //   } else {
//     //     setError('Something went wrong. Please try again.');
//     //   }
//     //   return;
//     // }
//     setModalOpen(false);
//     setForm(INITIAL_FORM);
//     setSuccessOpen(true);
//   };

//   const heroSection = useInView(0.05);
//   const aboutSection = useInView(0.1);
//   const expectSection = useInView(0.1);
//   const forYouSection = useInView(0.1);
//   const quoteSection = useInView(0.1);
//   const detailsSection = useInView(0.1);
//   const ctaSection = useInView(0.1);

//   const scrollTo = (id: string) => {
//     document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
//     setActiveSection(id);
//   };

//   return (
//     <div className="min-h-screen text-[#3d1f1f] overflow-x-hidden" style={{ background: '#fdf6f0', fontFamily: "'Inter', sans-serif" }}>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400;1,600&family=Inter:wght@300;400;500;600&display=swap');

//         * { box-sizing: border-box; }

//         @keyframes fadeUp {
//           from { opacity: 0; transform: translateY(30px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }
//         @keyframes fadeIn {
//           from { opacity: 0; } to { opacity: 1; }
//         }
//         @keyframes scaleIn {
//           from { opacity: 0; transform: scale(0.93); }
//           to   { opacity: 1; transform: scale(1); }
//         }
//         @keyframes shimmer {
//           0%, 100% { opacity: 0.3; transform: scale(1); }
//           50%       { opacity: 0.6; transform: scale(1.05); }
//         }
//         @keyframes floatAnim {
//           0%, 100% { transform: translateY(0px); }
//           50%       { transform: translateY(-10px); }
//         }
//         @keyframes gradientShift {
//           0%   { background-position: 0% 50%; }
//           50%  { background-position: 100% 50%; }
//           100% { background-position: 0% 50%; }
//         }
//         @keyframes spinSlow {
//           from { transform: rotate(0deg); }
//           to   { transform: rotate(360deg); }
//         }
//         @keyframes petalDrift {
//           0%   { transform: translateY(0px) rotate(0deg); opacity: 0.4; }
//           50%  { opacity: 0.7; }
//           100% { transform: translateY(-20px) rotate(15deg); opacity: 0.2; }
//         }

//         .anim-fadeUp  { animation: fadeUp 0.75s ease forwards; }
//         .anim-fadeIn  { animation: fadeIn 0.4s ease forwards; }
//         .anim-scaleIn { animation: scaleIn 0.45s ease forwards; }
//         .anim-float   { animation: floatAnim 4s ease-in-out infinite; }
//         .anim-shimmer { animation: shimmer 3.5s ease-in-out infinite; }

//         .d1 { animation-delay: 0.08s; }
//         .d2 { animation-delay: 0.16s; }
//         .d3 { animation-delay: 0.24s; }
//         .d4 { animation-delay: 0.32s; }
//         .d5 { animation-delay: 0.40s; }
//         .d6 { animation-delay: 0.48s; }
//         .d7 { animation-delay: 0.56s; }

//         .opacity-init { opacity: 0; }

//         .gradient-text {
//           background: linear-gradient(135deg, #b5636a 0%, #e8a598 50%, #c8856a 100%);
//           background-size: 200% 200%;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//           background-clip: text;
//           animation: gradientShift 4s ease infinite;
//         }

//         .glass {
//           background: rgba(255, 255, 255, 0.55);
//           backdrop-filter: blur(14px);
//           -webkit-backdrop-filter: blur(14px);
//           border: 1px solid rgba(213, 158, 140, 0.25);
//         }

//         .gold-border {
//           border: 1.5px solid rgba(197, 138, 113, 0.45);
//           box-shadow: 0 0 0 1px rgba(197,138,113,0.1), inset 0 0 20px rgba(255,220,200,0.06);
//         }

//         .card-hover {
//           transition: transform 0.3s ease, box-shadow 0.3s ease;
//         }
//         .card-hover:hover {
//           transform: translateY(-5px);
//           box-shadow: 0 20px 40px rgba(181, 99, 106, 0.13);
//         }

//         .btn-rose {
//           background: linear-gradient(135deg, #b5636a 0%, #c8856a 100%);
//           color: white;
//           transition: all 0.3s ease;
//           box-shadow: 0 4px 20px rgba(181,99,106,0.3);
//         }
//         .btn-rose:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 8px 30px rgba(181,99,106,0.42);
//         }
//         .btn-rose:active { transform: translateY(0); }
//         .btn-rose:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }

//         .btn-outline-rose {
//           border: 1.5px solid #b5636a;
//           color: #b5636a;
//           transition: all 0.3s ease;
//           background: transparent;
//         }
//         .btn-outline-rose:hover {
//           background: #b5636a;
//           color: white;
//           transform: translateY(-2px);
//         }

//         .nav-link-item {
//           position: relative;
//           color: #8b5e52;
//           transition: color 0.2s;
//         }
//         .nav-link-item::after {
//           content: '';
//           position: absolute;
//           bottom: -3px; left: 0;
//           width: 0; height: 1.5px;
//           background: #b5636a;
//           transition: width 0.3s ease;
//         }
//         .nav-link-item:hover { color: #b5636a; }
//         .nav-link-item:hover::after,
//         .nav-link-item.is-active::after { width: 100%; }
//         .nav-link-item.is-active { color: #b5636a; }

//         .countdown-cell {
//           background: rgba(255,255,255,0.7);
//           border: 1px solid rgba(197,138,113,0.28);
//           border-radius: 12px;
//           box-shadow: 0 3px 12px rgba(181,99,106,0.07);
//         }

//         .ornament {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           color: #c8856a;
//         }
//         .ornament::before, .ornament::after {
//           content: '';
//           flex: 1;
//           height: 1px;
//           background: linear-gradient(90deg, transparent, #c8856a55, transparent);
//         }

//         input, select, textarea {
//           transition: border-color 0.2s, box-shadow 0.2s;
//         }
//         input:focus, select:focus, textarea:focus {
//           outline: none;
//           border-color: #b5636a !important;
//           box-shadow: 0 0 0 3px rgba(181,99,106,0.1);
//         }

//         ::-webkit-scrollbar { width: 6px; }
//         ::-webkit-scrollbar-track { background: #fdf6f0; }
//         ::-webkit-scrollbar-thumb { background: #d5a08a; border-radius: 3px; }
//       `}</style>

//       {/* ── NAVBAR ── */}
//       <nav
//         className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
//         style={{
//           padding: scrolled ? '20px 0' : '20px 0',
//           background: scrolled ? 'rgba(253,246,240,0.85)' : 'rgba(253,246,240,0.85)',
//           backdropFilter: scrolled ? 'blur(14px)' : 'blur(14px)',
//           boxShadow: scrolled ? '0 1px 20px rgba(181,99,106,0.1)' : 'none',
//         }}
//       >
//         <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//           <button
//             onClick={() => scrollTo('hero')}
//             style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: 18, background: 'none', border: 'none', cursor: 'pointer' }}
//             // className="gradient-text"
//           >
//             Women Transform
//           </button>
//           <div style={{ display: 'flex', gap: 32, alignItems: 'center' }} className="hidden-mobile">
//             {[['about', 'About'], ['expect', 'Experience'], ['details', 'Details']].map(([id, label]) => (
//               <button
//                 key={id}
//                 onClick={() => scrollTo(id)}
//                 className={`nav-link-item ${activeSection === id ? 'is-active' : ''}`}
//                 style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}
//               >
//                 {label}
//               </button>
//             ))}
//           </div>
//           <button
//             onClick={() => setModalOpen(true)}
//             className="btn-rose"
//             style={{ fontSize: 13, fontWeight: 600, padding: '10px 22px', borderRadius: 50, border: 'none', cursor: 'pointer' }}
//           >
//             Register Now
//           </button>
//         </div>
//       </nav>

//       {/* ── HERO ── */}
//       <section id="hero" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden', background: 'linear-gradient(155deg, #f9ebe4 0%, #f5d8cc 30%, #fce8e0 60%, #f7ddd3 100%)', paddingTop: 100, paddingBottom: 60 }}>

//         {/* glow blobs */}
//         <div className="anim-shimmer" style={{ position: 'absolute', top: '20%', left: '15%', width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle, rgba(232,165,152,0.25) 0%, transparent 70%)', pointerEvents: 'none' }} />
//         <div className="anim-shimmer d3" style={{ position: 'absolute', bottom: '20%', right: '15%', width: 320, height: 320, borderRadius: '50%', background: 'radial-gradient(circle, rgba(200,133,106,0.2) 0%, transparent 70%)', pointerEvents: 'none' }} />

//         {/* floating petal dots */}
//         {[...Array(14)].map((_, i) => (
//           <div
//             key={i}
//             className="anim-float"
//             style={{
//               position: 'absolute',
//               top: `${8 + (i * 6.5) % 82}%`,
//               left: `${4 + (i * 7.3) % 92}%`,
//               width: 6 + (i % 5) * 2,
//               height: 6 + (i % 5) * 2,
//               borderRadius: '50% 0',
//               background: `rgba(213,158,140,${0.15 + (i % 4) * 0.07})`,
//               animationDelay: `${i * 0.4}s`,
//               animationDuration: `${3.5 + (i % 3)}s`,
//               pointerEvents: 'none',
//             }}
//           />
//         ))}

//         <div ref={heroSection.ref} style={{ position: 'relative', zIndex: 1, textAlign: 'center', maxWidth: 780, margin: '0 auto', padding: '0 24px' }}>

//           {/* <div className={heroSection.visible ? 'anim-fadeUp' : 'opacity-init'}>
//             <span style={{ display: 'inline-block', fontSize: 11, fontWeight: 600, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#b5636a', background: 'rgba(181,99,106,0.09)', border: '1px solid rgba(181,99,106,0.2)', borderRadius: 50, padding: '6px 18px', marginBottom: 20 }}>
//               A Christ-Centered Wellness Retreat for Women
//             </span>
//           </div> */}

//           <div className={heroSection.visible ? 'anim-fadeUp d1' : 'opacity-init'} style={{ fontFamily: "'Playfair Display', serif" }}>
//             <h1 style={{ margin: 0, lineHeight: 1.1 }}>
//               <span className="gradient-text" style={{ fontSize: 'clamp(48px, 9vw, 80px)', fontWeight: 700 }}>Women</span>
//               <br />
//               <span style={{ fontSize: 'clamp(52px, 10vw, 88px)', fontWeight: 700, fontStyle: 'italic', color: '#3d1f1f' }}>Transform</span>
//               <br />
//               <span style={{ fontSize: 'clamp(20px, 4vw, 32px)', fontWeight: 400, letterSpacing: '0.28em', textTransform: 'uppercase', color: '#8b5e52' }}>Retreat</span>
//             </h1>
//           </div>

//           <div className={`ornament ${heroSection.visible ? 'anim-fadeUp d2' : 'opacity-init'}`} style={{ margin: '16px auto', maxWidth: 340 }}>
//             <Heart size={13} fill="#c8856a" stroke="none" />
//             <span style={{ fontFamily: "'Playfair Display', serif", fontStyle: 'italic', color: '#c8856a', fontSize: 18 }}>Theme: Mother Wound</span>
//             <Heart size={13} fill="#c8856a" stroke="none" />
//           </div>

//           <div className={heroSection.visible ? 'anim-fadeUp d3' : 'opacity-init'}>
//             <p style={{ color: '#8b5e52', fontSize: 18, fontWeight: 300, letterSpacing: '0.06em', margin: '0 0 8px' }}>
//               Rest. Healing. Wholeness.&nbsp;&nbsp;
//               <span style={{ fontFamily: "'Playfair Display', serif", fontStyle: 'italic' }}>Mind, Body, Soul</span>
//             </p>
//           </div>

//           {/* event info chips */}
//           <div className={heroSection.visible ? 'anim-fadeUp d4' : 'opacity-init'} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 12, marginTop: 32 }}>
//             {[
//               { icon: <Calendar size={15} />, label: 'Date', value: 'May 23, 2026' },
//               { icon: <Clock size={15} />, label: 'Time', value: '10 AM – 2 PM PST' },
//               { icon: <MapPin size={15} />, label: 'Location', value: 'Menifee, CA' },
//             ].map(({ icon, label, value }) => (
//               <div key={label} className="glass gold-border card-hover" style={{ display: 'flex', alignItems: 'center', gap: 10, borderRadius: 16, padding: '10px 18px' }}>
//                 <span style={{ color: '#b5636a' }}>{icon}</span>
//                 <div style={{ textAlign: 'left' }}>
//                   <div style={{ fontSize: 9, color: '#b5636a', fontWeight: 600, letterSpacing: '0.15em', textTransform: 'uppercase' }}>{label}</div>
//                   <div style={{ fontSize: 13, color: '#3d1f1f', fontWeight: 500 }}>{value}</div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* countdown */}
//           {!registrationIsOpen && (
//             <div className={heroSection.visible ? 'anim-fadeUp d5' : 'opacity-init'} style={{ marginTop: 32 }}>
//               <p style={{ color: '#8b5e52', fontSize: 12, fontWeight: 500, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>Registration opens in</p>
//               <div style={{ display: 'flex', justifyContent: 'center', gap: 10 }}>
//                 {[
//                   { val: regCountdown.d, label: 'Days' },
//                   { val: regCountdown.h, label: 'Hours' },
//                   { val: regCountdown.m, label: 'Min' },
//                   { val: regCountdown.s, label: 'Sec' },
//                 ].map(({ val, label }) => (
//                   <div key={label} className="countdown-cell" style={{ width: 64, padding: '10px 0', textAlign: 'center' }}>
//                     <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, fontWeight: 700, color: '#b5636a' }}>{String(val).padStart(2, '0')}</div>
//                     <div style={{ fontSize: 9, color: '#8b5e52', letterSpacing: '0.12em', textTransform: 'uppercase', marginTop: 2 }}>{label}</div>
//                   </div>
//                 ))}
//               </div>
//               <p style={{ color: '#b5636a', fontSize: 11, marginTop: 10, fontWeight: 500 }}>Registration Opens May 1, 2026</p>
//             </div>
//           )}

//           {/* CTA */}
//           <div className={heroSection.visible ? 'anim-fadeUp d6' : 'opacity-init'} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 14, marginTop: 36 }}>
//             <button
//               onClick={() => setModalOpen(true)}
//               className="btn-rose"
//               style={{ padding: '16px 34px', borderRadius: 50, fontSize: 15, fontWeight: 600, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
//             >
//               <Sparkles size={18} />
//               {registrationIsOpen ? 'Register Now' : 'Pre-Register Now'}
//               <ArrowRight size={18} />
//             </button>
//             <button
//               onClick={() => scrollTo('expect')}
//               className="btn-outline-rose"
//               style={{ padding: '16px 30px', borderRadius: 50, fontSize: 15, fontWeight: 500, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
//             >
//               Learn More <ChevronDown size={16} />
//             </button>
//           </div>

//           {/* tagline */}
//           <div className={heroSection.visible ? 'anim-fadeUp d7' : 'opacity-init'} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 24, marginTop: 40, color: '#a07060', fontSize: 13 }}>
//             {['You Are Whole', 'You Are Worthy', 'You Are Loved'].map((t) => (
//               <span key={t} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
//                 <Heart size={11} fill="#c8856a" stroke="none" />
//                 {t}
//               </span>
//             ))}
//           </div>
//         </div>

//         {/* scroll cue */}
//         <button
//           onClick={() => scrollTo('flyer')}
//           className="anim-float"
//           style={{ position: 'absolute', bottom: 28, left: '50%', transform: 'translateX(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#b5636a', opacity: 0.55 }}
//         >
//           <ChevronDown size={30} />
//         </button>
//       </section>

//       {/* ── FLYER ── */}
//       <section id="flyer" style={{ padding: '64px 24px', background: '#fdf6f0', display: 'flex', justifyContent: 'center' }}>
//         <div className="anim-float gold-border" style={{ maxWidth: 820, width: '100%', borderRadius: 28, overflow: 'hidden', boxShadow: '0 28px 70px rgba(181,99,106,0.16)' }}>
//           <img
//             src="https://www.thetransformationcollective.org/wp-content/uploads/2026/04/WomenTransform.jpeg"
//             alt="Women Transform Retreat Flyer"
//             style={{ width: '100%', display: 'block', objectFit: 'cover' }}
//           />
//         </div>
//       </section>

//       {/* ── ABOUT ── */}
//       <section id="about" style={{ padding: '80px 24px', background: 'linear-gradient(180deg, #fdf6f0 0%, #f9ede6 100%)' }}>
//         <div ref={aboutSection.ref} style={{ maxWidth: 820, margin: '0 auto', textAlign: 'center' }}>

//           <div className={`ornament ${aboutSection.visible ? 'anim-fadeUp' : 'opacity-init'}`}>
//             <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#b5636a' }}>A Message for You</span>
//           </div>

//           <div className={aboutSection.visible ? 'anim-fadeUp d1' : 'opacity-init'} style={{ marginTop: 20 }}>
//             <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(32px, 5vw, 50px)', fontWeight: 700, lineHeight: 1.2, color: '#3d1f1f', margin: 0 }}>
//               You Are Not Alone.<br />
//               <span className="gradient-text" style={{ fontStyle: 'italic', fontWeight: 600 }}>And You Are Not Too Much.</span>
//             </h2>
//           </div>

//           <div className={aboutSection.visible ? 'anim-fadeUp d2' : 'opacity-init'} style={{ marginTop: 32, color: '#6b4c43', fontSize: 17, lineHeight: 1.8 }}>
//             <p>
//               There is a wound that many women carry in silence — one that shapes how we love, how we trust,
//               how we see ourselves, and how we show up in the world. It doesn't always have a name.
//               But today, we are going to give it one.
//             </p>
//             <p style={{ fontFamily: "'Playfair Display', serif", fontStyle: 'italic', fontSize: 26, color: '#b5636a', fontWeight: 600, margin: '24px 0' }}>
//               The Mother Wound.
//             </p>
//             <p>
//               Whether your relationship with your mother was painful, absent, complicated, or simply not what
//               you needed it to be — the effects can quietly follow you into adulthood, into your relationships,
//               into your sense of worth, and into the way you mother yourself and others.
//             </p>
//           </div>

//           <div className={`glass gold-border ${aboutSection.visible ? 'anim-scaleIn d3' : 'opacity-init'}`} style={{ marginTop: 40, borderRadius: 24, padding: '36px 40px' }}>
//             <p style={{ fontFamily: "'Playfair Display', serif", fontStyle: 'italic', fontSize: 22, color: '#b5636a', fontWeight: 600, lineHeight: 1.6, margin: 0 }}>
//               "But healing is possible. Wholeness is possible.<br />
//               And it starts with one brave step — showing up."
//             </p>
//             <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginTop: 16 }}>
//               {[...Array(5)].map((_, i) => <Star key={i} size={15} fill="#e8a598" stroke="none" />)}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ── WHAT TO EXPECT ── */}
//       <section id="expect" style={{ padding: '80px 24px', background: '#fdf6f0' }}>
//         <div ref={expectSection.ref} style={{ maxWidth: 1040, margin: '0 auto' }}>

//           <div className={`${expectSection.visible ? 'anim-fadeUp' : 'opacity-init'}`} style={{ textAlign: 'center', marginBottom: 56 }}>
//             <div className="ornament" style={{ maxWidth: 300, margin: '0 auto 16px' }}>
//               <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#b5636a' }}>The Experience</span>
//             </div>
//             <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(30px, 5vw, 48px)', fontWeight: 700, color: '#3d1f1f', margin: '0 0 12px' }}>What to Expect</h2>
//             <p style={{ color: '#8b5e52', fontSize: 16, maxWidth: 560, margin: '0 auto' }}>
//               This is not just an event. This is an experience — carefully and lovingly designed with you in mind.
//             </p>
//           </div>

//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 20 }}>
//             {[
//               { icon: <Wind size={22} />, title: 'Intentional Rest', desc: 'Permission to put everything down and simply breathe. You deserve this space entirely.', delay: 'd1' },
//               { icon: <Sparkles size={22} />, title: 'Upper Room Prayer', desc: 'A powerful, Spirit-led time of prayer and deep spiritual renewal for every soul.', delay: 'd2' },
//               { icon: <MessageCircle size={22} />, title: 'Super Surge Chat', desc: 'Raw, honest, healing conversation on the mother wound, breaking cycles, and reclaiming your identity.', delay: 'd3' },
//               { icon: <HandHeart size={22} />, title: 'Massages Available', desc: 'Because healing lives in the body too. Restore from the inside out, completely.', delay: 'd4' },
//               { icon: <Utensils size={22} />, title: 'Light Food Served', desc: 'Come nourished, leave restored. We take care of the whole you — mind, body, soul.', delay: 'd5' },
//               { icon: <Users size={22} />, title: 'Fellowship & Community', desc: 'Connect with women who get it — on the same journey, no judgment, only love.', delay: 'd6' },
//             ].map(({ icon, title, desc, delay }) => (
//               <div
//                 key={title}
//                 className={`glass gold-border card-hover ${expectSection.visible ? `anim-fadeUp ${delay}` : 'opacity-init'}`}
//                 style={{ borderRadius: 22, padding: '28px 26px' }}
//               >
//                 <div style={{ width: 48, height: 48, borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16, background: 'linear-gradient(135deg, rgba(181,99,106,0.1) 0%, rgba(200,133,106,0.15) 100%)' }}>
//                   <span style={{ color: '#b5636a' }}>{icon}</span>
//                 </div>
//                 <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 18, fontWeight: 700, color: '#3d1f1f', margin: '0 0 8px' }}>{title}</h3>
//                 <p style={{ color: '#8b5e52', fontSize: 13, lineHeight: 1.7, margin: 0 }}>{desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── IS THIS FOR YOU ── */}
//       <section style={{ padding: '80px 24px', background: 'linear-gradient(135deg, #f5e8e0 0%, #fce8de 100%)' }}>
//         <div ref={forYouSection.ref} style={{ maxWidth: 900, margin: '0 auto' }}>

//           <div className={`${forYouSection.visible ? 'anim-fadeUp' : 'opacity-init'}`} style={{ textAlign: 'center', marginBottom: 52 }}>
//             <div className="ornament" style={{ maxWidth: 280, margin: '0 auto 16px' }}>
//               <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#b5636a' }}>Is This For You?</span>
//             </div>
//             <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(30px, 5vw, 48px)', fontWeight: 700, color: '#3d1f1f', margin: 0 }}>
//               This Retreat Is For You If...
//             </h2>
//           </div>

//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))', gap: 14 }}>
//             {[
//               'You have struggled with feelings of unworthiness, abandonment, or not being enough',
//               'You have a complicated or painful relationship with your mother — past or present',
//               'You are breaking generational cycles and doing the hard inner work',
//               'You are a mother yourself and want to show up differently for your children',
//               'You simply need rest, community, and a safe place to exhale',
//               'You are ready — even if you are scared — to begin healing',
//             ].map((item, i) => (
//               <div
//                 key={i}
//                 className={`glass gold-border card-hover ${forYouSection.visible ? `anim-fadeUp d${i + 1}` : 'opacity-init'}`}
//                 style={{ display: 'flex', alignItems: 'flex-start', gap: 16, borderRadius: 20, padding: '18px 20px' }}
//               >
//                 <div style={{ width: 32, height: 32, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 2, background: 'linear-gradient(135deg, #b5636a, #c8856a)' }}>
//                   <CheckCircle size={16} color="white" />
//                 </div>
//                 <p style={{ color: '#6b4c43', fontSize: 14, lineHeight: 1.65, margin: 0 }}>{item}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── WHAT MAKES IT DIFFERENT ── */}
//       <section style={{ padding: '80px 24px', background: '#fdf6f0' }}>
//         <div ref={quoteSection.ref} style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center' }}>

//           <div className={`${quoteSection.visible ? 'anim-fadeUp' : 'opacity-init'}`}>
//             <div className="ornament" style={{ maxWidth: 360, margin: '0 auto 16px' }}>
//               <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#b5636a' }}>What Makes This Space Different</span>
//             </div>
//           </div>

//           <div className={`${quoteSection.visible ? 'anim-fadeUp d1' : 'opacity-init'}`} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 18, marginTop: 36 }}>
//             {[
//               { icon: <Shield size={26} />, title: 'Judgment-Free', desc: 'A safe, confidential environment where every woman is honored from the moment she walks in.' },
//               { icon: <Heart size={26} />, title: 'Spirit-Filled', desc: 'Rooted in faith, love, and the belief that every woman deserves access to deep healing.' },
//               { icon: <Flower2 size={26} />, title: 'Transformative', desc: 'We don\'t just gather — we transform. You will leave different than you arrived.' },
//             ].map(({ icon, title, desc }) => (
//               <div key={title} className="glass gold-border card-hover" style={{ borderRadius: 26, padding: '36px 28px', textAlign: 'center' }}>
//                 <div style={{ width: 60, height: 60, borderRadius: '50%', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, rgba(181,99,106,0.12), rgba(200,133,106,0.18))' }}>
//                   <span style={{ color: '#b5636a' }}>{icon}</span>
//                 </div>
//                 <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, fontWeight: 700, color: '#3d1f1f', margin: '0 0 10px' }}>{title}</h3>
//                 <p style={{ color: '#8b5e52', fontSize: 13, lineHeight: 1.7, margin: 0 }}>{desc}</p>
//               </div>
//             ))}
//           </div>

//           <div className={`glass gold-border ${quoteSection.visible ? 'anim-scaleIn d3' : 'opacity-init'}`} style={{ borderRadius: 26, padding: '40px', marginTop: 32 }}>
//             <p style={{ color: '#6b4c43', fontSize: 17, lineHeight: 1.8, margin: 0 }}>
//               What is spoken here, stays here.{' '}
//               <strong style={{ color: '#b5636a' }}>Your story is safe with us.</strong>
//               <br /><br />
//               We believe every woman deserves access to healing. We believe rest is not a luxury — it is a necessity.
//               And we believe that{' '}
//               <em style={{ fontFamily: "'Playfair Display', serif", color: '#b5636a', fontSize: 20 }}>
//                 you — yes, you — are worth every moment of this.
//               </em>
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* ── DETAILS ── */}
//       <section id="details" style={{ padding: '80px 24px', background: 'linear-gradient(135deg, #f8e8e0 0%, #fdf0ea 100%)' }}>
//         <div ref={detailsSection.ref} style={{ maxWidth: 900, margin: '0 auto' }}>

//           <div className={`${detailsSection.visible ? 'anim-fadeUp' : 'opacity-init'}`} style={{ textAlign: 'center', marginBottom: 52 }}>
//             <div className="ornament" style={{ maxWidth: 260, margin: '0 auto 16px' }}>
//               <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#b5636a' }}>Important Details</span>
//             </div>
//             <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(30px, 5vw, 48px)', fontWeight: 700, color: '#3d1f1f', margin: 0 }}>Mark Your Calendar</h2>
//           </div>

//           <div className={`${detailsSection.visible ? 'anim-fadeUp d1' : 'opacity-init'}`} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(370px, 1fr))', gap: 20 }}>
//             <div className="glass gold-border" style={{ borderRadius: 26, padding: '32px' }}>
//               <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, fontWeight: 700, color: '#3d1f1f', margin: '0 0 22px' }}>Event Details</h3>
//               {[
//                 { icon: <Calendar size={16} />, label: 'Date', value: 'Friday, May 23, 2026' },
//                 { icon: <Clock size={16} />, label: 'Time', value: '10:00 AM – 2:00 PM PST' },
//                 { icon: <MapPin size={16} />, label: 'Location', value: 'Menifee, CA' },
//                 { icon: <Users size={16} />, label: 'Attendees', value: 'Women Only' },
//                 { icon: <Shield size={16} />, label: 'Privacy', value: 'Strictly Confidential' },
//               ].map(({ icon, label, value }) => (
//                 <div key={label} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '12px 0', borderBottom: '1px solid rgba(197,138,113,0.12)' }}>
//                   <span style={{ color: '#b5636a' }}>{icon}</span>
//                   <div>
//                     <div style={{ fontSize: 9, color: '#b5636a', fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase' }}>{label}</div>
//                     <div style={{ fontSize: 14, color: '#3d1f1f', fontWeight: 500 }}>{value}</div>
//                   </div>
//                 </div>
//               ))}
//             </div>

//             <div className="glass gold-border" style={{ borderRadius: 26, padding: '32px' }}>
//               <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, fontWeight: 700, color: '#3d1f1f', margin: '0 0 22px' }}>Registration Info</h3>
//               {[
//                 { icon: <AlertCircle size={16} />, text: 'Registration required — Walk-ins are not accepted' },
//                 { icon: <Users size={16} />, text: 'Women only event' },
//                 { icon: <Shield size={16} />, text: 'Strictly confidential space' },
//                 { icon: <CheckCircle size={16} />, text: 'Seating is extremely limited — do not wait' },
//                 { icon: <Sparkles size={16} />, text: 'Light food served — come as you are' },
//               ].map(({ icon, text }, i) => (
//                 <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 12, padding: '12px 0', borderBottom: '1px solid rgba(197,138,113,0.12)' }}>
//                   <span style={{ color: '#b5636a', flexShrink: 0, marginTop: 2 }}>{icon}</span>
//                   <span style={{ color: '#6b4c43', fontSize: 14, lineHeight: 1.6 }}>{text}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ── CTA ── */}
//       <section style={{ padding: '96px 24px', background: 'linear-gradient(155deg, #b5636a 0%, #c8856a 50%, #d4927a 100%)' }}>
//         <div ref={ctaSection.ref} style={{ maxWidth: 700, margin: '0 auto', textAlign: 'center' }}>

//           <div className={`${ctaSection.visible ? 'anim-fadeUp' : 'opacity-init'}`}>
//             <Flower2 size={38} className="anim-float" style={{ margin: '0 auto 16px', color: 'rgba(255,255,255,0.8)', display: 'block' }} />
//             <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: 700, color: 'white', lineHeight: 1.2, margin: 0 }}>
//               Come Heal With Us.<br />
//               <span style={{ fontSize: 'clamp(22px, 3.5vw, 36px)', fontStyle: 'italic', fontWeight: 400, opacity: 0.9 }}>You Deserve This.</span>
//             </h2>
//           </div>

//           <div className={`${ctaSection.visible ? 'anim-fadeUp d2' : 'opacity-init'}`} style={{ marginTop: 22 }}>
//             <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 17, lineHeight: 1.75, margin: 0 }}>
//               We know it takes courage to look at the places that hurt. We are here to walk alongside you,
//               to create space for your voice, and to remind you that on the other side of this wound
//               is a woman who is <em style={{ fontFamily: "'Playfair Display', serif" }}>free, whole, and fully herself.</em>
//             </p>
//           </div>

//           <div className={`${ctaSection.visible ? 'anim-fadeUp d3' : 'opacity-init'}`} style={{ marginTop: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
//             <button
//               onClick={() => setModalOpen(true)}
//               style={{ background: 'white', color: '#b5636a', padding: '18px 44px', borderRadius: 50, fontSize: 16, fontWeight: 600, border: 'none', cursor: 'pointer', boxShadow: '0 8px 32px rgba(0,0,0,0.15)', display: 'flex', alignItems: 'center', gap: 8, transition: 'all 0.3s ease' }}
//               onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.transform = 'translateY(-3px)'; (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 14px 40px rgba(0,0,0,0.2)'; }}
//               onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.transform = 'translateY(0)'; (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 8px 32px rgba(0,0,0,0.15)'; }}
//             >
//               <Sparkles size={20} />
//               {registrationIsOpen ? 'Register Now — Spots Fill Fast' : 'Pre-Register — Spots Fill Fast'}
//               <ArrowRight size={20} />
//             </button>
//             <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 12, margin: 0 }}>Only a limited number of seats are available. Secure yours today.</p>
//           </div>

//           <div className={`${ctaSection.visible ? 'anim-fadeUp d4' : 'opacity-init'}`} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 24, marginTop: 44, color: 'rgba(255,255,255,0.65)', fontSize: 13 }}>
//             {['You Are Whole', 'You Are Worthy', 'You Are Loved'].map((t) => (
//               <span key={t} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
//                 <Heart size={11} fill="white" stroke="none" />
//                 {t}
//               </span>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── FOOTER ── */}
//       <footer style={{ padding: '44px 24px', background: '#3d1f1f', textAlign: 'center' }}>
//         <p style={{ fontFamily: "'Playfair Display', serif", fontStyle: 'italic', color: '#d5a08a', fontSize: 20, margin: '0 0 6px' }}>Women Transform Retreat</p>
//         <p style={{ color: '#8b6060', fontSize: 13, margin: '0 0 16px' }}>Mother Wound &nbsp;·&nbsp; May 23, 2026 &nbsp;·&nbsp; Menifee, CA</p>
//         <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginBottom: 16 }}>
//           {[...Array(5)].map((_, i) => <div key={i} style={{ width: 6, height: 6, borderRadius: '50%', background: '#b5636a', opacity: 0.45 }} />)}
//         </div>
//         <p style={{ color: '#705050', fontSize: 12, margin: 0 }}>You Are Not Alone. You Are Not Too Much. You Are Ready to Heal.</p>
//       </footer>

//       {/* ── REGISTRATION MODAL ── */}
//       {modalOpen && (
//         <div
//           className="anim-fadeIn"
//           style={{ position: 'fixed', inset: 0, zIndex: 60, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, background: 'rgba(61,31,31,0.6)', backdropFilter: 'blur(6px)' }}
//           onClick={(e) => { if (e.target === e.currentTarget) setModalOpen(false); }}
//         >
//           <div
//             className="anim-scaleIn"
//             style={{ width: '100%', maxWidth: 520, background: '#fdf6f0', borderRadius: 28, boxShadow: '0 30px 80px rgba(61,31,31,0.3)', overflow: 'hidden', maxHeight: '92vh', overflowY: 'auto' }}
//           >
//             {/* modal header */}
//             <div style={{ padding: '32px 32px 24px', background: 'linear-gradient(135deg, #f5e0d8, #fce8de)', position: 'relative' }}>
//               <button
//                 onClick={() => setModalOpen(false)}
//                 style={{ position: 'absolute', top: 18, right: 18, width: 32, height: 32, borderRadius: '50%', background: 'rgba(255,255,255,0.7)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
//               >
//                 <X size={15} color="#8b5e52" />
//               </button>
//               <div style={{ textAlign: 'center' }}>
//                 <Flower2 size={30} color="#b5636a" style={{ margin: '0 auto 12px', display: 'block' }} />
//                 <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 24, fontWeight: 700, color: '#3d1f1f', margin: '0 0 4px' }}>Reserve Your Seat</h2>
//                 <p style={{ color: '#8b5e52', fontSize: 13, margin: 0 }}>Women Transform Retreat · May 23, 2026</p>
//               </div>
//             </div>

//             <form onSubmit={handleSubmit} style={{ padding: '28px 32px', display: 'flex', flexDirection: 'column', gap: 16 }}>
//               {!registrationIsOpen && (
//                 <div style={{ borderRadius: 16, padding: '14px 16px', fontSize: 13, color: '#b5636a', background: 'rgba(181,99,106,0.08)', border: '1px solid rgba(181,99,106,0.2)', display: 'flex', alignItems: 'flex-start', gap: 8 }}>
//                   <AlertCircle size={15} style={{ flexShrink: 0, marginTop: 1 }} />
//                   <span>Registration officially opens May 1, 2026. Submit your info now to be first in line!</span>
//                 </div>
//               )}

//               {[
//                 { key: 'full_name', label: 'Full Name', type: 'text', placeholder: 'Your full name', required: true },
//                 { key: 'email', label: 'Email Address', type: 'email', placeholder: 'your@email.com', required: true },
//                 { key: 'phone', label: 'Phone Number', type: 'tel', placeholder: '(Optional)', required: false },
//               ].map(({ key, label, type, placeholder, required }) => (
//                 <div key={key}>
//                   <label style={{ display: 'block', fontSize: 10, fontWeight: 600, color: '#8b5e52', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 6 }}>
//                     {label} {required && <span style={{ color: '#b5636a' }}>*</span>}
//                   </label>
//                   <input
//                     type={type}
//                     value={form[key as keyof FormData]}
//                     onChange={(e) => setForm({ ...form, [key]: e.target.value })}
//                     placeholder={placeholder}
//                     required={required}
//                     style={{ width: '100%', padding: '12px 16px', borderRadius: 12, border: '1.5px solid #e5c9bc', background: 'rgba(255,255,255,0.8)', color: '#3d1f1f', fontSize: 14 }}
//                   />
//                 </div>
//               ))}

//               <div>
//                 <label style={{ display: 'block', fontSize: 10, fontWeight: 600, color: '#8b5e52', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 6 }}>
//                   How Did You Hear About Us?
//                 </label>
//                 <select
//                   value={form.hear_about}
//                   onChange={(e) => setForm({ ...form, hear_about: e.target.value })}
//                   style={{ width: '100%', padding: '12px 16px', borderRadius: 12, border: '1.5px solid #e5c9bc', background: 'rgba(255,255,255,0.8)', color: '#3d1f1f', fontSize: 14 }}
//                 >
//                   <option value="">Select one...</option>
//                   <option value="instagram">Instagram</option>
//                   <option value="facebook">Facebook</option>
//                   <option value="friend">A Friend</option>
//                   <option value="church">Church / Ministry</option>
//                   <option value="flyer">Flyer</option>
//                   <option value="other">Other</option>
//                 </select>
//               </div>

//               <div>
//                 <label style={{ display: 'block', fontSize: 10, fontWeight: 600, color: '#8b5e52', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 6 }}>
//                   My Intention for This Retreat
//                 </label>
//                 <textarea
//                   value={form.intention}
//                   onChange={(e) => setForm({ ...form, intention: e.target.value })}
//                   placeholder="Share what you hope to experience or receive... (Optional)"
//                   rows={3}
//                   style={{ width: '100%', padding: '12px 16px', borderRadius: 12, border: '1.5px solid #e5c9bc', background: 'rgba(255,255,255,0.8)', color: '#3d1f1f', fontSize: 14, resize: 'none' }}
//                 />
//               </div>

//               {error && (
//                 <div style={{ borderRadius: 12, padding: '12px 14px', fontSize: 13, color: '#dc2626', background: 'rgba(239,68,68,0.07)', border: '1px solid rgba(239,68,68,0.18)', display: 'flex', alignItems: 'center', gap: 8 }}>
//                   <AlertCircle size={14} />
//                   {error}
//                 </div>
//               )}

//               <button
//                 type="submit"
//                 disabled={submitting}
//                 className="btn-rose"
//                 style={{ padding: '16px', borderRadius: 14, fontSize: 15, fontWeight: 600, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
//               >
//                 {submitting ? (
//                   <>
//                     <div style={{ width: 16, height: 16, border: '2px solid rgba(255,255,255,0.4)', borderTopColor: 'white', borderRadius: '50%', animation: 'spinSlow 0.8s linear infinite' }} />
//                     Reserving Your Seat...
//                   </>
//                 ) : (
//                   <>
//                     <Heart size={17} fill="white" stroke="none" />
//                     {registrationIsOpen ? 'Reserve My Seat' : 'Pre-Register Now'}
//                   </>
//                 )}
//               </button>

//               <p style={{ textAlign: 'center', color: '#a07060', fontSize: 11, margin: 0, lineHeight: 1.6 }}>
//                 By registering, you agree to keep all shared content confidential.<br />Women only event. Seating is strictly limited.
//               </p>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* ── SUCCESS MODAL ── */}
//       {successOpen && (
//         <div
//           className="anim-fadeIn"
//           style={{ position: 'fixed', inset: 0, zIndex: 60, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, background: 'rgba(61,31,31,0.6)', backdropFilter: 'blur(6px)' }}
//           onClick={(e) => { if (e.target === e.currentTarget) setSuccessOpen(false); }}
//         >
//           <div
//             className="anim-scaleIn"
//             style={{ width: '100%', maxWidth: 460, background: '#fdf6f0', borderRadius: 28, padding: 48, boxShadow: '0 30px 80px rgba(61,31,31,0.3)', textAlign: 'center' }}
//           >
//             <div className="anim-float" style={{ width: 80, height: 80, borderRadius: '50%', margin: '0 auto 24px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #b5636a, #c8856a)' }}>
//               <CheckCircle size={38} color="white" />
//             </div>
//             <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 32, fontWeight: 700, color: '#3d1f1f', margin: '0 0 12px' }}>You Are Registered!</h2>
//             <p style={{ color: '#8b5e52', lineHeight: 1.7, margin: '0 0 24px' }}>
//               Your seat has been reserved. We are so grateful you said yes to yourself.
//               We will be in touch with details closer to the event.
//             </p>
//             <div style={{ borderRadius: 20, padding: '22px 28px', background: 'rgba(181,99,106,0.07)', border: '1px solid rgba(181,99,106,0.18)' }}>
//               <p style={{ fontFamily: "'Playfair Display', serif", fontStyle: 'italic', color: '#b5636a', fontSize: 18, lineHeight: 1.6, margin: 0 }}>
//                 "On the other side of this wound is a woman who is free, whole, and fully herself."
//               </p>
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'center', gap: 6, margin: '20px 0' }}>
//               {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="#e8a598" stroke="none" />)}
//             </div>
//             <button
//               onClick={() => setSuccessOpen(false)}
//               className="btn-rose"
//               style={{ padding: '14px 36px', borderRadius: 50, fontSize: 15, fontWeight: 600, border: 'none', cursor: 'pointer' }}
//             >
//               See You There!
//             </button>
//           </div>
//         </div>
//       )}

//       {/* ── FLOATING BUTTON ── */}
//       <button
//         onClick={() => setInfoOpen(true)}
//         className="anim-float"
//         style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 40, width: 56, height: 56, borderRadius: '50%', background: 'linear-gradient(135deg, #b5636a, #c8856a)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 20px rgba(181,99,106,0.4)', transition: 'transform 0.3s ease, box-shadow 0.3s ease' }}
//         onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.1)'; }}
//         onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)'; }}
//       >
//         <Heart size={22} fill="white" stroke="none" />
//         <span style={{ position: 'absolute', top: 2, right: 2, width: 14, height: 14, borderRadius: '50%', background: '#3d8b5e', border: '2px solid #fdf6f0' }} />
//       </button>

//       {/* ── INFO DRAWER ── */}
//       {infoOpen && (
//         <div
//           className="anim-fadeIn"
//           style={{ position: 'fixed', inset: 0, zIndex: 50, display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', padding: 16, background: 'rgba(61,31,31,0.35)', backdropFilter: 'blur(4px)' }}
//           onClick={(e) => { if (e.target === e.currentTarget) setInfoOpen(false); }}
//         >
//           <div
//             className="anim-scaleIn"
//             style={{ width: '100%', maxWidth: 340, background: '#fdf6f0', borderRadius: 26, padding: 28, boxShadow: '0 20px 60px rgba(61,31,31,0.2)' }}
//           >
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
//               <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, fontWeight: 700, color: '#3d1f1f', margin: 0 }}>Quick Info</h3>
//               <button onClick={() => setInfoOpen(false)} style={{ width: 32, height: 32, borderRadius: '50%', background: '#f0e0d8', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                 <X size={14} color="#8b5e52" />
//               </button>
//             </div>
//             <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
//               {[
//                 { icon: <Calendar size={14} />, text: 'Friday, May 23, 2026' },
//                 { icon: <Clock size={14} />, text: '10:00 AM – 2:00 PM PST' },
//                 { icon: <MapPin size={14} />, text: 'Menifee, CA' },
//                 { icon: <Shield size={14} />, text: 'Women Only · Confidential' },
//                 { icon: <Users size={14} />, text: 'Limited Seating — Register Early' },
//               ].map(({ icon, text }, i) => (
//                 <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, color: '#6b4c43', fontSize: 13 }}>
//                   <span style={{ color: '#b5636a' }}>{icon}</span>
//                   {text}
//                 </div>
//               ))}
//             </div>
//             <button
//               onClick={() => { setInfoOpen(false); setModalOpen(true); }}
//               className="btn-rose"
//               style={{ width: '100%', marginTop: 22, padding: '13px', borderRadius: 14, fontSize: 14, fontWeight: 600, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
//             >
//               <Sparkles size={15} />
//               Register Now
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }





import { useState, useEffect, useRef } from 'react';
// import { createClient } from '@supabase/supabase-js';
import {
  Calendar,
  Clock,
  MapPin,
  Heart,
  Sparkles,
  Users,
  Shield,
  ChevronDown,
  X,
  CheckCircle,
  Flower2,
  Wind,
  Star,
  MessageCircle,
  HandHeart,
  Utensils,
  ArrowRight,
  AlertCircle,
  Handshake,
  CookingPot,
  CloudSun,
} from 'lucide-react';

// const supabase = createClient(
//   import.meta.env.VITE_SUPABASE_URL,
//   import.meta.env.VITE_SUPABASE_ANON_KEY
// );

const REGISTRATION_OPEN_DATE = new Date('2026-05-01T00:00:00');

function useCountdown(target: Date) {
  const [diff, setDiff] = useState(target.getTime() - Date.now());
  useEffect(() => {
    const id = setInterval(() => setDiff(target.getTime() - Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);
  const total = Math.max(0, diff);
  const d = Math.floor(total / 86400000);
  const h = Math.floor((total % 86400000) / 3600000);
  const m = Math.floor((total % 3600000) / 60000);
  const s = Math.floor((total % 60000) / 1000);
  return { d, h, m, s, past: diff <= 0 };
}

function useInView(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return { ref, visible };
}

interface FormData {
  full_name: string;
  email: string;
  phone: string;
  hear_about: string;
  intention: string;
}

const INITIAL_FORM: FormData = {
  full_name: '',
  email: '',
  phone: '',
  hear_about: '',
  intention: '',
};

export default function WomenTransform() {
  const [modalOpen, setModalOpen] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [infoOpen, setInfoOpen] = useState(false);
  const [form, setForm] = useState<FormData>(INITIAL_FORM);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const regCountdown = useCountdown(REGISTRATION_OPEN_DATE);
  const registrationIsOpen = regCountdown.past;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (modalOpen || successOpen || infoOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [modalOpen, successOpen, infoOpen]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!form.full_name.trim() || !form.email.trim()) {
      setError('Please fill in your name and email.');
      return;
    }
    setSubmitting(true);
    // const { error: dbErr } = await supabase.from('registrations').insert([form]);
    setSubmitting(false);
    // if (dbErr) {
    //   if (dbErr.code === '23505') {
    //     setError('This email is already registered.');
    //   } else {
    //     setError('Something went wrong. Please try again.');
    //   }
    //   return;
    // }
    setModalOpen(false);
    setForm(INITIAL_FORM);
    setSuccessOpen(true);
  };

  const heroSection = useInView(0.05);
  const aboutSection = useInView(0.1);
  const expectSection = useInView(0.1);
  const forYouSection = useInView(0.1);
  const quoteSection = useInView(0.1);
  const detailsSection = useInView(0.1);
  const ctaSection = useInView(0.1);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setActiveSection(id);
  };

  return (
    <div className="min-h-screen text-[#3d1f1f]  overflow-x-hidden" style={{ background: '#fafaf9', fontFamily: "'Inter', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=Inter:wght@300;400;500;600&display=swap');

        * { box-sizing: border-box; }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(25px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; } to { opacity: 1; }
        }
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-15px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes subtleFloat {
          0%, 100% { transform: translateY(0px); }
          50%       { transform: translateY(-6px); }
        }

        .anim-fadeUp  { animation: fadeUp 0.6s ease forwards; }
        .anim-fadeIn  { animation: fadeIn 0.5s ease forwards; }
        .anim-slideDown { animation: slideDown 0.5s ease forwards; }
        .anim-float   { animation: subtleFloat 3s ease-in-out infinite; }

        .d1 { animation-delay: 0.08s; }
        .d2 { animation-delay: 0.16s; }
        .d3 { animation-delay: 0.24s; }
        .d4 { animation-delay: 0.32s; }
        .d5 { animation-delay: 0.40s; }
        .d6 { animation-delay: 0.48s; }
        .d7 { animation-delay: 0.56s; }

        .opacity-init { opacity: 0; }

        .gradient-text {
          background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .accent-text {
          color: #c2777d;
        }

        .subtle-card {
          border: 1px solid #e5e5e4;
          transition: all 0.3s ease;
          background: #ffffff;
        }

        .subtle-card:hover {
          border-color: #c2777d;
          box-shadow: 0 8px 24px rgba(91, 124, 89, 0.08);
          transform: translateY(-3px);
        }


        .opacity-init { opacity: 0; }

        .gradient-text {
          background: linear-gradient(135deg, #b5636a 0%, #e8a598 50%, #c8856a 100%);
          background-size: 200% 200%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: gradientShift 4s ease infinite;
        }

        .glass {
          background: rgba(255, 255, 255, 0.55);
          backdrop-filter: blur(14px);
          -webkit-backdrop-filter: blur(14px);
          border: 1px solid rgba(213, 158, 140, 0.25);
        }

        .gold-border {
          border: 1.5px solid rgba(197, 138, 113, 0.45);
          box-shadow: 0 0 0 1px rgba(197,138,113,0.1), inset 0 0 20px rgba(255,220,200,0.06);
        }

        .card-hover {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .card-hover:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(181, 99, 106, 0.13);
        }

        .btn-rose {
          background: linear-gradient(135deg, #b5636a 0%, #c8856a 100%);
          color: white;
          transition: all 0.3s ease;
          box-shadow: 0 4px 20px rgba(181,99,106,0.3);
        }
        .btn-rose:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 30px rgba(181,99,106,0.42);
        }
        .btn-rose:active { transform: translateY(0); }
        .btn-rose:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }

        .btn-outline-rose {
          border: 1.5px solid #b5636a;
          color: #b5636a;
          transition: all 0.3s ease;
          background: transparent;
        }
        .btn-outline-rose:hover {
          background: #b5636a;
          color: white;
          transform: translateY(-2px);
        }

        .btn-primary {
          background: #374151;
          color: white;
          transition: all 0.3s ease;
        }
        .btn-primary:hover {
          background: #1f2937;
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(23, 23, 23, 0.15);
        }
        .btn-primary:active { transform: translateY(0); }
        .btn-primary:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }

        .btn-secondary {
          border: 1.5px solid #374151;
          color: #374151;
          transition: all 0.3s ease;
          background: transparent;
        }
        .btn-secondary:hover {
          background: #374151;
          color: white;
          transform: translateY(-2px);
        }

        .btn-accent {
          background: #c2777d;
          color: white;
          transition: all 0.3s ease;
        }
        .btn-accent:hover {
          background: #4a6548;
          transform: translateY(-2px);
        }

        .nav-link-item {
          position: relative;
          color: #6b7280;
          transition: color 0.2s;
          font-weight: 500;
        }
        .nav-link-item::after {
          content: '';
          position: absolute;
          bottom: -5px; left: 0;
          width: 0; height: 2px;
          background: #c2777d;
          transition: width 0.3s ease;
        }
        .nav-link-item:hover { color: #374151; }
        .nav-link-item:hover::after,
        .nav-link-item.is-active::after { width: 100%; }
        .nav-link-item.is-active { color: #374151; }

        .countdown-cell {
          background: #f9fafb;
          border: 1px solid #e5e5e4;
          border-radius: 8px;
        }

        .divider-line {
          height: 1px;
          background: linear-gradient(90deg, transparent, #d4d4d8, transparent);
        }

        input, select, textarea {
          transition: border-color 0.2s, box-shadow 0.2s;
          border-color: #e5e5e4;
        }
        input:focus, select:focus, textarea:focus {
          outline: none;
          border-color: #c2777d !important;
          box-shadow: 0 0 0 3px rgba(91, 124, 89, 0.08);
        }

        ::-webkit-scrollbar { width: 6px; }
        ::-webkit-scrollbar-track { background: #fafaf9; }
        ::-webkit-scrollbar-thumb { background: #d4d4d8; border-radius: 3px; }
      `}</style>


      {/* ── HERO ── */}
      <section id="hero" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden', background: 'linear-gradient(155deg, #f9ebe4 0%, #f5d8cc 30%, #fce8e0 60%, #f7ddd3 100%)', paddingTop: 100, paddingBottom: 60 }}>

        <img
          src="http://roseofjericho-cd.org/wp-content/uploads/2026/05/womensTransform.jpeg"
          alt="Women Transform Retreat Flyer"
          className='blur-2xl'
          style={{ position: 'absolute', top: 0, right: 0, width: '100%', height: '100%', pointerEvents: 'none', objectFit: "cover" }}
        />
        {/* subtle gradient accent */}
        <div style={{ position: 'absolute', top: 0, right: 0, width: '50%', height: '100%', background: 'linear-gradient(135deg, rgba(91,124,89,0.04) 0%, transparent 60%)', pointerEvents: 'none' }} />

        {/* floating accent circles */}
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="anim-float"
            style={{
              position: 'absolute',
              top: `${10 + (i * 15) % 80}%`,
              left: `${5 + (i * 18) % 85}%`,
              width: 2 + (i % 3) * 1,
              height: 2 + (i % 3) * 1,
              borderRadius: '50%',
              background: `rgba(91,124,89,${0.2 + (i % 3) * 0.1})`,
              animationDelay: `${i * 0.3}s`,
              animationDuration: `${4 + (i % 2)}s`,
              pointerEvents: 'none',
            }}
          />
        ))}

        <div ref={heroSection.ref} style={{ position: 'relative', zIndex: 1, textAlign: 'center', maxWidth: 900, margin: '0 auto', padding: '0 32px' }}>

          <div className={heroSection.visible ? 'anim-fadeUp d1' : 'opacity-init'} style={{ fontFamily: "'Sora', sans-serif" }}>
            <h1 style={{ margin: 0, lineHeight: 1.15 }}>
              <h1>
                <span className="gradient-text" style={{ fontSize: 'clamp(48px, 9vw, 80px)', fontWeight: 700 }}>Women</span>
                <span style={{ fontSize: 'clamp(52px, 10vw, 88px)', fontWeight: 700, fontStyle: 'italic', color: '#3d1f1f' }}>Transform</span>
              </h1>
              <span style={{ fontSize: 'clamp(20px, 4vw, 28px)', fontWeight: 500, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#6b7280', display: 'block', marginTop: 12 }}>Wellness Retreat</span>
            </h1>
          </div>

          <div style={{ width: 48, height: 1, background: '#c2777d', margin: '24px auto' }} className={heroSection.visible ? 'anim-fadeUp d2' : 'opacity-init'} />

          <div className="flex flex-row justify-center items-center" style={{ margin: '16px auto', maxWidth: 400, textAlign: "center" }}>
            <Heart size={13} fill="#c8856a" stroke="none" />
            <span style={{ fontFamily: "'Playfair Display', serif", fontStyle: 'italic', color: '#c8856a', fontSize: 16 }}>Theme: Naming What You Have Been Carrying</span>
            <Heart size={13} fill="#c8856a" stroke="none" />
          </div>

          <div className={heroSection.visible ? 'anim-fadeUp d3' : 'opacity-init'}>
            <p style={{ color: '#8b5e52', fontSize: 18, fontWeight: 300, letterSpacing: '0.06em', margin: '0 0 8px' }}>
              Rest. Healing. Wholeness.&nbsp;&nbsp;
              <span style={{ fontFamily: "'Playfair Display', serif", fontStyle: 'italic' }}>Mind, Body, Soul</span>
            </p>
          </div>

          {/* event info chips */}
          <div className={heroSection.visible ? 'anim-fadeUp d4' : 'opacity-init'} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 12, marginTop: 32 }}>
            {[
              { icon: <Calendar size={15} />, label: 'Date', value: 'June 27, 2026' },
              { icon: <Clock size={15} />, label: 'Time', value: '10:00 AM – 2:00 PM PST' },
              { icon: <MapPin size={15} />, label: 'Location', value: 'Private location in Menifee, CA' },
            ].map(({ icon, label, value }) => (
              <div key={label} className="glass gold-border card-hover" style={{ display: 'flex', alignItems: 'center', gap: 10, borderRadius: 16, padding: '10px 18px' }}>
                <span style={{ color: '#b5636a' }}>{icon}</span>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: 9, color: '#b5636a', fontWeight: 600, letterSpacing: '0.15em', textTransform: 'uppercase' }}>{label}</div>
                  <div style={{ fontSize: 13, color: '#3d1f1f', fontWeight: 500 }}>{value}</div>
                </div>
              </div>
            ))}
          </div>

          {/* countdown */}
          {!registrationIsOpen && (
            <div className={heroSection.visible ? 'anim-fadeUp d5' : 'opacity-init'} style={{ marginTop: 32 }}>
              <p style={{ color: '#8b5e52', fontSize: 12, fontWeight: 500, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>Registration opens in</p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: 10 }}>
                {[
                  { val: regCountdown.d, label: 'Days' },
                  { val: regCountdown.h, label: 'Hours' },
                  { val: regCountdown.m, label: 'Min' },
                  { val: regCountdown.s, label: 'Sec' },
                ].map(({ val, label }) => (
                  <div key={label} className="countdown-cell" style={{ width: 64, padding: '10px 0', textAlign: 'center' }}>
                    <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, fontWeight: 700, color: '#b5636a' }}>{String(val).padStart(2, '0')}</div>
                    <div style={{ fontSize: 9, color: '#8b5e52', letterSpacing: '0.12em', textTransform: 'uppercase', marginTop: 2 }}>{label}</div>
                  </div>
                ))}
              </div>
              <p style={{ color: '#b5636a', fontSize: 11, marginTop: 10, fontWeight: 500 }}>Registration Opens May 1, 2026</p>
            </div>
          )}

          {/* CTA */}
          <div className={heroSection.visible ? 'anim-fadeUp d6' : 'opacity-init'} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 14, marginTop: 36 }}>
            <button
              // onClick={() => setModalOpen(true)}
              onClick={() => window.open("https://www.eventbrite.com/e/woman-transform-retreat-june-2026-naming-what-you-have-been-carrying-tickets-1990343692563?aff=oddtdtcreator", "_blank")}
              className="btn-rose"
              style={{ padding: '16px 34px', borderRadius: 50, fontSize: 15, fontWeight: 600, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
            >
              <Sparkles size={18} />
              {registrationIsOpen ? 'Register Now' : 'Pre-Register Now'}
              <ArrowRight size={18} />
            </button>
            <button
              onClick={() => scrollTo('expect')}
              className="btn-outline-rose"
              style={{ padding: '16px 30px', borderRadius: 50, fontSize: 15, fontWeight: 500, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
            >
              Learn More <ChevronDown size={16} />
            </button>
          </div>

          {/* tagline */}
          <div className={heroSection.visible ? 'anim-fadeUp d7' : 'opacity-init'} style={{ marginTop: 48, color: '#8b5e52', fontSize: 14, lineHeight: 1.8 }}>
            <p style={{ margin: '0 0 12px', fontWeight: 500 }}>You don't have to carry it anymore.</p>
            <p style={{ margin: 0, fontSize: 16, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#b5636a' }}>Come. Be Seen. Be Healed. Be Set Free.</p>
          </div>
        </div>

        {/* scroll cue */}
        <button
          onClick={() => scrollTo('flyer')}
          className="anim-float"
          style={{ position: 'absolute', bottom: 32, left: '50%', transform: 'translateX(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', opacity: 0.6 }}
        >
          <ChevronDown size={24} />
        </button>
      </section>

      {/* ── FLYER ── */}
      <section id="flyer" style={{ padding: '60px 24px', background: '#fdf6f0', display: 'flex', justifyContent: 'center' }}>
        <div className="subtle-card" style={{ maxWidth: 820, width: '100%', borderRadius: 12, overflow: 'hidden' }}>
          <img
            src="http://roseofjericho-cd.org/wp-content/uploads/2026/05/womensTransform.jpeg"
            alt="Women Transform Retreat Flyer"
            style={{ width: '100%', display: 'block', objectFit: 'cover' }}
          />
        </div>
      </section>


      {/* ── FEATURES ── */}
      <section id="expect" style={{ padding: '80px 24px', background: '#1f2937' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', textAlign: 'center' }}>
          <div className={`${ctaSection.visible ? 'anim-fadeUp' : 'opacity-init'}`} style={{ marginBottom: 56 }}>
            <span style={{ fontSize: 12, fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#c2777d' }}>What You'll Experience</span>
            <h2 style={{ fontFamily: "'Sora', sans-serif", fontSize: 'clamp(28px, 5vw, 40px)', fontWeight: 700, color: '#fdf6f0', margin: '12px 0 0' }}>A Journey of Healing</h2>
          </div>

          <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4'>
            {[
              { icon: <CloudSun color='#fdf6f0' />, title: 'Faith Centered', desc: 'Rooted in faith and spiritual renewal' },
              { icon: <Heart color='#fdf6f0' />, title: 'Healing & Restoration', desc: 'Deep emotional and spiritual healing' },
              { icon: <Handshake color='#fdf6f0' />, title: 'Meaningful Connection', desc: 'Connect with women on the same journey' },
              { icon: <CookingPot color='#fdf6f0' />, title: 'Nourishment', desc: 'Food for body and soul' },
              { icon: <Shield color='#fdf6f0' />, title: 'Safe Space', desc: 'Confidential, judgment-free environment' },
            ].map(({ icon, title, desc }, i) => (
              <div key={i} className='flex flex-col justify-center items-center' style={{ textAlign: 'center', padding: '20px 12px' }}>
                <p style={{ fontSize: 36, marginBottom: 12, maxWidth: 40 }}>{icon}</p>
                <h3 style={{ fontFamily: "'Sora', sans-serif", fontSize: 14, fontWeight: 700, color: '#fdf6f0', margin: '0 0 6px', textTransform: 'capitalize', letterSpacing: '0.02em' }}>{title}</h3>
                <p style={{ color: '#9ca3af', fontSize: 13, margin: 0, lineHeight: 1.5 }}>{desc}</p>
              </div>
            ))}
          </div>

          <div style={{ marginTop: 56, padding: '32px 28px', borderRadius: 8, background: '#f3f4f6', border: '1px solid #e5e5e4' }}>
            <p style={{ color: '#1f2937', fontSize: 16, lineHeight: 1.8, margin: 0, fontWeight: 500 }}>
              <span className="accent-text" style={{ fontWeight: 700 }}>You are not alone. You are seen. You are loved. You are whole.</span>
            </p>
          </div>
        </div>
      </section>

      {/* ── IS THIS FOR YOU ── */}
      <section style={{ padding: '80px 24px', background: '#f9fafb' }}>
        <div ref={forYouSection.ref} style={{ maxWidth: 1000, margin: '0 auto' }}>

          <div className={`${forYouSection.visible ? 'anim-fadeUp' : 'opacity-init'}`} style={{ textAlign: 'center', marginBottom: 56 }}>
            <span style={{ fontSize: 12, fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#c2777d' }}>Is This For You?</span>
            <h2 style={{ fontFamily: "'Sora', sans-serif", fontSize: 'clamp(28px, 5vw, 44px)', fontWeight: 700, color: '#1f2937', margin: '12px 0 0' }}>
              This Retreat Is For You If...
            </h2>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
            {[
              'You have struggled with feelings of unworthiness, abandonment, or not being enough',
              'You have a complicated or painful relationship with your mother — past or present',
              'You are breaking generational cycles and doing the hard inner work',
              'You are a mother yourself and want to show up differently for your children',
              'You simply need rest, community, and a safe place to exhale',
              'You are ready — even if you are scared — to begin healing',
            ].map((item, i) => (
              <div
                key={i}
                className={`subtle-card ${forYouSection.visible ? `anim-fadeUp d${i + 1}` : 'opacity-init'}`}
                style={{ display: 'flex', alignItems: 'flex-start', gap: 14, borderRadius: 8, padding: '20px 18px' }}
              >
                <div style={{ width: 24, height: 24, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 2, background: '#c2777d' }}>
                  <CheckCircle size={14} color="white" fill="#c2777d" />
                </div>
                <p style={{ color: '#6b7280', fontSize: 14, lineHeight: 1.6, margin: 0 }}>{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHAT MAKES IT DIFFERENT ── */}
      <section style={{ padding: '80px 24px', background: '#f9ebe4' }}>
        <div ref={quoteSection.ref} style={{ maxWidth: 1100, margin: '0 auto', textAlign: 'center' }}>

          <div className={`${quoteSection.visible ? 'anim-fadeUp' : 'opacity-init'}`} style={{ marginBottom: 56 }}>
            <span style={{ fontSize: 12, fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#c2777d' }}>What Makes This Space Different</span>
            <h2 style={{ fontFamily: "'Sora', sans-serif", fontSize: 'clamp(28px, 5vw, 44px)', fontWeight: 700, color: '#1f2937', margin: '12px 0 0' }}>Created With Care</h2>
          </div>

          <div className={`${quoteSection.visible ? 'anim-fadeUp d1' : 'opacity-init'}`} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 20, marginTop: 0 }}>
            {[
              { icon: <Shield size={28} />, title: 'Judgment-Free', desc: 'A safe, confidential environment where every woman is honored from the moment she walks in.' },
              { icon: <Heart size={28} />, title: 'Spirit-Filled', desc: 'Rooted in faith, love, and the belief that every woman deserves access to deep healing.' },
              { icon: <Flower2 size={28} />, title: 'Transformative', desc: 'We don&apos;t just gather — we transform. You will leave different than you arrived.' },
            ].map(({ icon, title, desc }) => (
              <div key={title} className="subtle-card " style={{ borderRadius: 8, padding: '32px 24px', textAlign: 'center' }}>
                <div style={{ width: 56, height: 56, borderRadius: '50%', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(91, 124, 89, 0.08)', color: '#c2777d' }}>
                  <span style={{ color: '#b5636a' }}>{icon}</span>
                </div>
                <h3 style={{ fontFamily: "'Sora', sans-serif", fontSize: 18, fontWeight: 700, color: '#1f2937', margin: '0 0 10px' }}>{title}</h3>
                <p style={{ color: '#9ca3af', fontSize: 14, lineHeight: 1.6, margin: 0 }}>{desc}</p>
              </div>
            ))}
          </div>

          <div className={`subtle-card ${quoteSection.visible ? 'anim-fadeUp d3' : 'opacity-init'}`} style={{ borderRadius: 8, padding: '36px 32px', marginTop: 40 }}>
            <p style={{ color: '#6b7280', fontSize: 16, lineHeight: 1.8, margin: 0 }}>
              <span className="accent-text" style={{ fontWeight: 700 }}>What is spoken here, stays here.</span>{' '}Your story is safe with us.
              <br /><br />
              We believe every woman deserves access to healing. We believe rest is not a luxury — it&apos;s a necessity.
              And we believe that{' '}
              <span className="accent-text" style={{ fontWeight: 700, fontSize: 17 }}>
                you — yes, you — are worth every moment of this.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* ── DETAILS ── */}
      <section id="details" style={{ padding: '80px 24px', background: '#f9fafb' }}>
        <div ref={detailsSection.ref} style={{ maxWidth: 900, margin: '0 auto' }}>

          <div className={`${detailsSection.visible ? 'anim-fadeUp' : 'opacity-init'}`} style={{ textAlign: 'center', marginBottom: 56 }}>
            <span style={{ fontSize: 12, fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#c2777d' }}>Important Details</span>
            <h2 style={{ fontFamily: "'Sora', sans-serif", fontSize: 'clamp(28px, 5vw, 44px)', fontWeight: 700, color: '#1f2937', margin: '12px 0 0' }}>Mark Your Calendar</h2>
          </div>

          <div className={`${detailsSection.visible ? 'anim-fadeUp d1' : 'opacity-init'}`} style={{ display: 'grid', gap: 0 }}>
            <div className="subtle-card" style={{ borderRadius: 8, padding: '32px', borderBottom: 'none' }}>
              <h3 style={{ fontFamily: "'Sora', sans-serif", fontSize: 18, fontWeight: 700, color: '#1f2937', margin: '0 0 24px' }}>Event Details</h3>
              {[
                { icon: <Calendar size={18} />, label: 'Date', value: 'Friday, June 27, 2026' },
                { icon: <Clock size={18} />, label: 'Time', value: '10:00 AM – 2:00 PM PST' },
                { icon: <MapPin size={18} />, label: 'Location', value: 'Menifee, CA' },
                { icon: <Users size={18} />, label: 'Attendees', value: 'Women Only' },
                { icon: <Shield size={18} />, label: 'Privacy', value: 'Strictly Confidential' },
              ].map(({ icon, label, value }, idx) => (
                <div key={label} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 0', borderBottom: idx < 4 ? '1px solid #e5e5e4' : 'none' }}>
                  <span style={{ color: '#c2777d' }}>{icon}</span>
                  <div>
                    <div style={{ fontSize: 10, color: '#9ca3af', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase' }}>{label}</div>
                    <div style={{ fontSize: 14, color: '#1f2937', fontWeight: 500 }}>{value}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* <div className="glass gold-border" style={{ borderRadius: 26, padding: '32px' }}>
              <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, fontWeight: 700, color: '#3d1f1f', margin: '0 0 22px' }}>To Donate</h3>
              <div style={{ textAlign: 'center' }}>
                <Heart size={20} fill="#c8856a" stroke="none" style={{ margin: '0 auto 12px', display: 'block' }} />
                <p style={{ color: '#3d1f1f', fontSize: 16, fontWeight: 600, margin: '0 0 8px' }}>Zelle to</p>
                <p style={{ color: '#6b4c43', fontSize: 14, margin: '0 0 20px', fontFamily: 'monospace' }}>info@roseofjericho-cd.org</p>
                <div style={{ width: 180, height: 180, margin: '0 auto', background: '#f0e8e0', borderRadius: 12, padding: 8 }}>
                  <svg viewBox="0 0 100 100" style={{ width: '100%', height: '100%' }}>
                    <rect width="100" height="100" fill="white" />
                    <text x="50" y="50" textAnchor="middle" dominantBaseline="middle" style={{ fontSize: '10px', fill: '#666' }}>[QR Code Placeholder]</text>
                  </svg>
                </div>
                <p style={{ color: '#b5636a', fontSize: 14, fontWeight: 600, margin: '16px 0 0', fontStyle: 'italic' }}>zelle</p>
              </div>
            </div> */}
          </div>
        </div>
      </section>


      {/* ── CTA ── */}
      <section style={{ padding: '96px 24px', background: '#1f2937' }}>
        <div ref={ctaSection.ref} style={{ maxWidth: 700, margin: '0 auto', textAlign: 'center' }}>

          <div className={`${ctaSection.visible ? 'anim-fadeUp' : 'opacity-init'}`}>
            <Flower2 size={36} className="anim-float" style={{ margin: '0 auto 20px', color: '#c2777d', display: 'block' }} />
            <h2 style={{ fontFamily: "'Sora', sans-serif", fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: 700, color: 'white', lineHeight: 1.2, margin: 0 }}>
              Come Heal With Us
              <br />
              <span style={{ fontSize: 'clamp(20px, 3.5vw, 32px)', fontWeight: 500, color: '#c2777d' }}>You Deserve This</span>
            </h2>
          </div>

          <div className={`${ctaSection.visible ? 'anim-fadeUp d2' : 'opacity-init'}`} style={{ marginTop: 24 }}>
            <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: 16, lineHeight: 1.75, margin: 0 }}>
              We know it takes courage to look at the places that hurt. We are here to walk alongside you,
              to create space for your voice, and to remind you that on the other side of this wound
              is a woman who is <span style={{ color: '#c2777d', fontWeight: 600 }}>free, whole, and fully herself.</span>
            </p>
          </div>

          <div className={`${ctaSection.visible ? 'anim-fadeUp d3' : 'opacity-init'}`} style={{ marginTop: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
            <button
              // onClick={() => setModalOpen(true)}
              onClick={() => window.open("https://www.eventbrite.com/e/woman-transform-retreat-june-2026-naming-what-you-have-been-carrying-tickets-1990343692563?aff=oddtdtcreator", "_blank")}
              className="btn-primary"
              style={{ padding: '16px 40px', borderRadius: 6, fontSize: 15, fontWeight: 600, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, transition: 'all 0.3s ease', background: '#c2777d' }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.background = '#4a6548'; (e.currentTarget as HTMLButtonElement).style.transform = 'translateY(-2px)'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.background = '#c2777d'; (e.currentTarget as HTMLButtonElement).style.transform = 'translateY(0)'; }}
            >
              <Sparkles size={18} />
              {registrationIsOpen ? 'Register Now' : 'Pre-Register'}
              <ArrowRight size={18} />
            </button>
            <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 12, margin: 0 }}>Limited seats available. Secure yours today.</p>
          </div>

          <div className={`${ctaSection.visible ? 'anim-fadeUp d4' : 'opacity-init'}`} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 24, marginTop: 48, color: 'rgba(255,255,255,0.65)', fontSize: 13 }}>
            {['You Are Whole', 'You Are Worthy', 'You Are Loved'].map((t) => (
              <span key={t} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <Heart size={12} fill="#c2777d" stroke="none" />
                {t}
              </span>
            ))}
          </div>
        </div>
      </section>


      {/* ── FLOATING BUTTON ── */}
      <button
        onClick={() => setInfoOpen(true)}
        className="anim-float"
        style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 40, width: 56, height: 56, borderRadius: '50%', background: '#c2777d', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 20px rgba(91, 124, 89, 0.3)', transition: 'transform 0.3s ease, box-shadow 0.3s ease' }}
        onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.1)'; (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 8px 28px rgba(91, 124, 89, 0.4)'; }}
        onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)'; (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 4px 20px rgba(91, 124, 89, 0.3)'; }}
      >
        <Heart size={20} fill="white" stroke="none" />
        <span style={{ position: 'absolute', top: 0, right: 0, width: 12, height: 12, borderRadius: '50%', background: '#ef4444', border: '2px solid white' }} />
      </button>

      {/* ── INFO DRAWER ── */}
      {infoOpen && (
        <div
          className="anim-fadeIn"
          style={{ position: 'fixed', inset: 0, zIndex: 50, display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', padding: 16, background: 'rgba(0,0,0,0.3)', backdropFilter: 'blur(4px)' }}
          onClick={(e) => { if (e.target === e.currentTarget) setInfoOpen(false); }}
        >
          <div
            className="anim-slideDown"
            style={{ width: '100%', maxWidth: 360, background: 'white', borderRadius: 12, padding: 28, boxShadow: '0 20px 60px rgba(0,0,0,0.15)', borderTop: '2px solid #c2777d' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
              <h3 style={{ fontFamily: "'Sora', sans-serif", fontSize: 18, fontWeight: 700, color: '#1f2937', margin: 0 }}>Event Details</h3>
              <button onClick={() => setInfoOpen(false)} style={{ width: 32, height: 32, borderRadius: '50%', background: '#f3f4f6', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background 0.2s' }} onMouseEnter={(e) => { e.currentTarget.style.background = '#e5e5e4'; }} onMouseLeave={(e) => { e.currentTarget.style.background = '#f3f4f6'; }}>
                <X size={16} color="#6b7280" />
              </button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              {[
                { icon: <Calendar size={16} />, text: 'Friday, June 27, 2026' },
                { icon: <Clock size={16} />, text: '10:00 AM – 2:00 PM PST' },
                { icon: <MapPin size={16} />, text: 'Menifee, CA' },
                { icon: <Shield size={16} />, text: 'Women Only · Confidential' },
                { icon: <Users size={16} />, text: 'Limited Seating' },
              ].map(({ icon, text }, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, color: '#6b7280', fontSize: 14 }}>
                  <span style={{ color: '#c2777d', flexShrink: 0 }}>{icon}</span>
                  {text}
                </div>
              ))}
            </div>
            <button
              // onClick={() => { setInfoOpen(false); setModalOpen(true); }}
              // onClick={() => setModalOpen(true)}
              onClick={() => { setInfoOpen(false); window.open("https://www.eventbrite.com/e/woman-transform-retreat-june-2026-naming-what-you-have-been-carrying-tickets-1990343692563?aff=oddtdtcreator", "_blank") }}
              className="btn-primary"
              style={{ width: '100%', marginTop: 24, padding: '12px', borderRadius: 6, fontSize: 14, fontWeight: 600, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
            >
              <Sparkles size={16} />
              Register Now
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
